// ui/PageHeader — one page title, one primary action, everything else in an
// overflow menu (Design Standard v1: Hick, Von Restorff). `primary` is a node
// (usually <Button variant="primary">); `overflow` is [{label, onClick, danger}].
import React, { useEffect, useRef, useState } from 'react';
import { MoreHorizontal } from 'lucide-react';
import Button from './button';
import './ds.css';

export default function PageHeader({ title, subtitle, primary = null, secondary = null, overflow = [], className = '' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    const esc = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('mousedown', close); document.removeEventListener('keydown', esc); };
  }, [open]);
  return (
    <header className={`ds-page-header ${className}`}>
      <div className="ds-page-header__text">
        <h1 className="ds-page-header__title">{title}</h1>
        {subtitle ? <p className="ds-page-header__sub">{subtitle}</p> : null}
      </div>
      <div className="ds-page-header__actions">
        {secondary}
        {overflow.length ? (
          <div className="ds-menu" ref={ref}>
            <Button variant="ghost" iconOnly aria-label="More actions" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
              <MoreHorizontal size={16} />
            </Button>
            {open ? (
              <div className="ds-menu__list" role="menu">
                {overflow.map((item) => (
                  <button key={item.label} type="button" role="menuitem"
                    className={`ds-menu__item${item.danger ? ' is-danger' : ''}`}
                    onClick={() => { setOpen(false); item.onClick?.(); }}>
                    {item.label}
                  </button>
                ))}
              </div>
            ) : null}
          </div>
        ) : null}
        {primary}
      </div>
    </header>
  );
}
